// Copyright (c) 2019 Deere & Company

import './app-header.scss';
import AppGreeting from './app-greeting';
import AppLogo from './app-logo';
import AppNavigation from './app-navigation';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { withRouter } from 'react-router-dom';

const AppHeader = () => (
    <div>
        <div className="app-header">
            <div className="confidential-logo-group">
                <AppLogo />
            </div>
            <div className="app-title-section">
                <div className="title-and-greeting">
                    <h1 className="app-title">
                        <div><FormattedMessage id="WARRANTY_ADMIN" /></div>
                    </h1>
                    <AppGreeting user="Warranty User" />
                </div>
            </div>
        </div>
        <AppNavigation />
    </div>
);

AppHeader.displayName = 'AppHeader';

export default withRouter(AppHeader);
